import type { Message, MessageSenderRole } from '@swiss-magic/shared-types';

// Shared between the player (086) and director (087) thread views. `myRole`
// is the viewer's own role so their bubbles align right; the other side aligns
// left. data-testid / data-role are preserved for the existing E2E selectors.
export function MessageList({
  messages,
  myRole,
}: {
  messages: Message[];
  myRole: MessageSenderRole;
}) {
  return (
    <div className="flex flex-1 flex-col gap-2 overflow-y-auto p-4">
      {messages.map((m) => (
        <div
          key={m.id}
          data-testid="message-bubble"
          data-role={m.senderRole}
          className={`max-w-[80%] whitespace-pre-wrap rounded-lg px-3 py-2 text-sm ${
            m.senderRole === myRole
              ? 'self-end bg-primary text-primary-foreground'
              : 'self-start bg-muted'
          }`}
        >
          {m.body}
        </div>
      ))}
    </div>
  );
}
